import React, { useState } from "react";
import { Button, Input } from "antd";
import PromoCodePreview from "./PromoCodePreview";
import "./index.scss";

// A promo code, asked for in a corner of the page rather than a box of its own.
// It stays a link until somebody opens it, because an open field sends people
// who have no code off to look for one. Opened, it is the field and the check
// under it (PromoCodePreview). A code already typed keeps it open.
//
// Used by the sign up's review step and the billing page's plans, so both ask
// for a code the same way.
function PromoCodeField({ promoCode, onChange, organizationId, packetId, isMonthly, trialing }) {
   const [isOpen, setIsOpen] = useState(() => Boolean(promoCode));

   return (
      <div className="billing-promo-field">
         {isOpen ? (
            <>
               <label htmlFor="promo-code">Promo code</label>
               <Input
                  id="promo-code"
                  value={promoCode}
                  onChange={(e) => onChange(e.target.value)}
                  placeholder="Enter promo code"
                  autoFocus={!promoCode}
               />
               <PromoCodePreview
                  organizationId={organizationId}
                  packetId={packetId}
                  isMonthly={isMonthly}
                  promoCode={promoCode}
                  trialing={trialing}
               />
            </>
         ) : (
            <Button type="link" className="billing-promo-field__toggle" onClick={() => setIsOpen(true)}>
               Have a promo code?
            </Button>
         )}
      </div>
   );
}

export default PromoCodeField;
